import 'css-chunksrc/client/scenes/projectExpenseCreation/form/expenseTypeSelect/expenseTypeCreation/styles.scss';export default {
  "form": "_form_5t149_1",
  "iconBox": "_iconBox_5t149_16",
  "icon": "_icon_5t149_16",
  "input": "_input_5t149_32",
  "colorPicker": "_colorPicker_5t149_57",
  "button": "_button_5t149_62",
  "enableCreate": "_enableCreate_5t149_83",
  "plusSign": "_plusSign_5t149_90"
};